import I18n from 'I18n';
import CreateActivityButton from 'crm-activity-creator-widgets/buttons/CreateActivityButton';
import { useHasScope } from 'crm-activity-creator-data/auth/hooks/useHasScope';
import { NOTES_EDIT_SEAT_GATE } from 'crm-activity-creator-data/auth/gateConstants';
import { useIsUngated } from 'crm-activity-creator-data/auth/hooks/useIsUngated';
import { jsx as _jsx } from "react/jsx-runtime";
const NOTES_EDIT_SCOPE = 'notes-edit';
function CreateNoteButton({
  interactionName,
  objectId,
  objectTypeId,
  taskId,
  buttonSize,
  isOverflow = false,
  onClickActionComplete
}) {
  const isUngatedForNotesEditSeat = useIsUngated(NOTES_EDIT_SEAT_GATE);
  const hasNotesEditScope = useHasScope(NOTES_EDIT_SCOPE);
  const tooltip = isUngatedForNotesEditSeat && !hasNotesEditScope ? I18n.text('createActivityButtons.tooltip.noteDisabled') : undefined;
  return /*#__PURE__*/_jsx(CreateActivityButton, {
    interactionName: interactionName,
    objectId: objectId,
    objectTypeId: objectTypeId,
    taskId: taskId,
    buttonSize: buttonSize,
    disabled: isUngatedForNotesEditSeat && !hasNotesEditScope,
    isOverflow: isOverflow,
    onClick: onClickActionComplete,
    onboardingSelector: "create-engagement-note",
    seleniumSelector: "create-engagement-note-button",
    "data-test-id": "create-engagement-note-button",
    tooltipMessage: tooltip
  });
}
export default CreateNoteButton;